import { createActionTypes } from "../../create_action_types";

/**
 * Create action creator for decrementing page for a context
 * @param {string} resourceName
 * @returns {function}
 */
export function createDecrementPageActionCreator(resourceName) {
  const actionTypes = createActionTypes(resourceName);
  return queryObject => {
    return {
      type: actionTypes.decrementPage,
      payload: {
        queryObject
      }
    };
  };
}
